import { Outlet } from 'react-router-dom';

import SettingsSidebar from './SettingsSidebar';
import './settings-tables.css';

const Settings = () => {
  return (
    <div className="grid grid-cols-1 gap-[0px] lg:gap-[20px] lg:grid-cols-[repeat(auto-fit,minmax(200px,1fr))]">
      <SettingsSidebar />
      <div className="settings-content col-span-4 w-full bg-white p-[16px] md:border-[8px] md:border-[#F6F6F6] md:p-[24px]">
        <Outlet />
      </div>
    </div>
  );
};

export default Settings;
